import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const ListAutorizarRequisasMantenimiento = async() => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListAutorizarRequisasMantenimiento`, 'POST')
    return result;
}

// LISTA DE REQUISAS ASIGNADAS 
export const ListRequisasMantenimiento = async(dates) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListRequisasMantenimiento`, 'POST',dates)
    return result;
}

export const ListAutorizarRequisasMantenimientoMateriales = async() => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListAutorizarRequisasMantenimientoMateriales`, 'GET')
    return result;
}

export const ListAutorizarRequisasMantenimientoMASS = async(dates) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListAutorizarRequisasMantenimientoMASS`, 'GET', dates)
    return result;
}

export const ListAutorizarRequisasMantenimientoUniformes = async(dates) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListAutorizarRequisasMantenimientoUniformes`, 'GET', dates)
    return result;
}

export const ListRequisasPendienteDespachoMantenimiento = async(dates) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListRequisasPendienteDespachoMantenimiento`, 'POST', dates)
    return result;
}

export const SPPermisosRequisasDeMateriales = async(detalles, ClaveAutorizacion) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/SPPermisosRequisasDeMateriales`, 'POST', {detalles, ClaveAutorizacion})
    return result;
}

// CANCELAR REQUISA MANTENIMIENTO
export const cancelarRequisasMantenimiento = async(data) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/cancelarRequisasMantenimiento`, 'POST', data)
    return result;
}

export const getListadoRequisaMateriales = async (Data) => {
    const result  = await PrivateInterceptor(`Mantenimiento/Requisas/listadoRequisas`, 'POST', {Data})
    return result; 
}

//Listado detalle Requisa de Materiales

export const listadoEncRequisaMateriales = async (IdRequisa) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/encabezadoRequisa/${IdRequisa}`, 'GET')
    return result;
}

export const detRequisaMateriales = async (IdRequisa) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/detallesRequisa/${IdRequisa}`, 'GET')
    return result;
}

export const ultimoIdRequisa = async () => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ultimoIdRequisa`, 'GET')
    return result;
}

export const allRequisasEnc = async () => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/encabezadoRequisaAll`, 'GET');
    return result;
}

 export const authByUserRol = async (data) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/rolesRequisa`, 'POST', data);
    return result;
 }

 export const getOrdenesTrabajo = async (data) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ordenesTrabajo`, 'GET', data);
    return result;
 }

 export const IURequisaMateriales = async (data) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/IURequisaMateriales`, 'POST', data);
    return result;
 }
 
 export const IURequisaMaterialesEliminar = async (data) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/IURequisaMaterialesEliminar`, 'POST', data);
    return result;
 }

 
